import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/user/auth.service';
import { isPlatformBrowser } from '@angular/common';

/**
 * Guard that blocks navigation until the logged-in user has a date of birth set.
 *
 * Allowed pages even when DOB is missing:
 *   – /privacy-policy
 *   – /terms-of-service
 *   – /newuser is handled by a separate guard.
 */
export const dobGuard: CanActivateFn = (_route, state) => {
  const platformId = inject(PLATFORM_ID);

  // Skip guard execution during SSR
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const auth = inject(AuthService);
  const router = inject(Router);

  const allowedPaths = ['/privacy-policy', '/terms-of-service'];
  if (allowedPaths.includes(state.url)) {
    return true;
  }

  return auth.currentUser$.pipe(
    take(1),
    map(user => {
      if (!user) {
        // Not logged in – allow navigation normally
        return true;
      }

      if (user.dateOfBirth) {
        return true;
      }
      // Logged in but missing DOB – redirect to birthday setup
      return router.createUrlTree(['/newuser']);
    }),
  );
};
